// extracted by mini-css-extract-plugin
export default {"FotterBox":"fotter_FotterBox__cVLb7"};